export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '官方认证入口',
      desc: '7777影院、777777影院、77777影院等数字变体统一官方导航，杜绝山寨仿冒站点，保障观影安全。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载体验',
      desc: '全球CDN加速节点覆盖，高清视频流畅播放不卡顿，支持多种清晰度自适应切换。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日片源同步',
      desc: '与各大影视平台同步更新，热门电影电视剧第一时间上线，追剧党不再错过任何更新。',
    },
    {
      icon: 'ri-device-line',
      title: '全终端适配',
      desc: '完美适配电脑、平板、手机等所有设备，无论在家还是通勤途中，随时随地畅享高清影视。',
    },
    {
      icon: 'ri-shield-star-line',
      title: '纯净观影环境',
      desc: '无弹窗广告干扰，专注内容本身，打造沉浸式观影空间，让你的每一分钟都花在好片上。',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            为什么选择777影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大核心优势，为您打造安全、流畅、纯净的高清观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}